import { render, staticRenderFns } from "./HomeProfesor.vue?vue&type=template&id=79d7e9b6&scoped=true"
import script from "./HomeProfesor.vue?vue&type=script&lang=js"
export * from "./HomeProfesor.vue?vue&type=script&lang=js"
import style0 from "./HomeProfesor.vue?vue&type=style&index=0&id=79d7e9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d7e9b6",
  null
  
)

export default component.exports